// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  queueId: __t.u64().primaryKey().name("queue_id"),
  versonaId: __t.u64().name("versona_id"),
  identity: __t.identity(),
  arrivedTick: __t.u64().name("arrived_tick"),
  expiresTick: __t.u64().name("expires_tick"),
});
